import { AdminAppState, PlaceEntry } from '../../state';
import { getPlace } from './get-place';

export const getPlacePageTitle = (placeKey: string) => (
  store: AdminAppState,
): PlaceEntry['place']['pageTitle'] => getPlace(placeKey)(store).pageTitle;
